import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ConfirmDialogResult } from '../../../infrastructure/types';

import { ConfirmDialog, ConfirmDialogOptions } from './confirm-dialog';

export const defaultConfirmDialogOptions: ConfirmDialogOptions = {
  title: 'Are you sure?',
  leftButton: 'Cancel',
  width: '510px',
  height: '204px',
  discourageConfirmation: false,
  isDangerous: false
};

export const openConfirmDialog = (dialog: MatDialog, options: ConfirmDialogOptions) => {
  const { width, height, ...restOption } = options;
  const {
    height: defaultHeight,
    width: defaultWidth,
    ...restDefaultOptions
  } = defaultConfirmDialogOptions;

  return dialog.open(ConfirmDialog, {
    width: width || defaultWidth,
    height: height || defaultHeight,
    restoreFocus: false,    
    data: {
      ...restDefaultOptions,
      ...restOption
    }
  });
};

export const openRejectConfirmDialog = (
  dialog: MatDialog, 
  options: ConfirmDialogOptions
): MatDialogRef<ConfirmDialog, ConfirmDialogResult> => {
  const { width, height, ...restOption } = options;
  const {
    height: defaultHeight,
    width: defaultWidth,
    ...restDefaultOptions
  } = defaultConfirmDialogOptions;

  return dialog.open<ConfirmDialog, ConfirmDialogOptions, ConfirmDialogResult>(
    ConfirmDialog, 
    {
      width: width || defaultWidth,
      height: height || defaultHeight,
      restoreFocus: false,    
      data: {
        ...restDefaultOptions,
        ...restOption,
        showTextarea: true
      }
    }
  );
};
